<template>
    <header class="o-section__header o-section__header--inline">
      <h2 class="o-playlist__heading">De lijst</h2>
      <div class="o-form__field">
        <input type="text" class="o-form__text" placeholder="Zoek track of artiest" id="filter-edition" @input="filter">
      </div>
    </header>
</template>

<script>
export default {
  name: 'hitlistEditions',
  methods: {
    filter(evt) {
      this.$store.dispatch('hitlist/search', { query: evt.target.value });
    }
  },
};
</script>
